document.addEventListener('DOMContentLoaded', function() {
  // Inicializar Swiper
  // @ts-ignore - Swiper está cargado desde un CDN externo
  var swiper = new Swiper('.text-slider', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 25
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30
      },
    }
  });
});
